import React from 'react'
import styled, { DefaultTheme } from 'styled-components'
import personUploading from '../../../../../../../../assets/images/spa/person_uploading.svg'
import { Button } from 'spa/member/components/Button'
import { JobOfferSummaryCard } from 'spa/member/components/WorkPreference/Registration/JobOfferSummaryCard'
import { JobOfferSummary } from 'javascripts/api/generated'
import { breakpoints } from 'spa/config/styled'
import { useWindowWidth } from 'spa/hooks/useWindowWidth'

type Props = {
  jobOfferSummary: JobOfferSummary
}

const RegistrationFinishContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2.5rem 1rem 2rem;

  @media ${props => props.theme.media.md} {
    padding: 5rem 2.5rem 1rem;
  }
`

const Title = styled.h1`
  text-align: center;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.7;
  margin-bottom: 0;

  @media ${props => props.theme.media.md} {
    font-size: 2rem;
  }
`

const SubTitle = styled.div`
  padding: 2rem 0;
  font-size: .875rem;
  line-height: 1.5rem;
`

const ActionLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
`

const ActionLinkArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${props => props.theme.members.colors.silver._10};
  width: 343px;
  padding: 2rem 1.5rem;

  @media ${props => props.theme.media.md} {
    width: 544px;
    padding: 1.5rem;
  }
`

const ActionDescription = styled.div`
  font-size: .875rem;
  font-weight: 700;
  line-height: 1.5rem;
  text-align: center;
`

const JobOfferCardContainer = styled.div`
  width: 100%;
  padding: 1rem 0 2.5rem;
`

const Image = styled.img`
  padding: 1.25rem;
  width: 110px;
  height: 112px;
  box-sizing: content-box;
`

const ActionAnchor = styled.a`
  padding-top: 1.25rem;
`

const ActionButton = styled(Button)`
  background-color: ${props => props.theme.members.colors.appleGreen._60};
  color: ${props => props.theme.members.colors.white};
  font-size: .875rem;
  font-weight: 700;
  padding-left: 2rem;
  padding-right: 2rem;

  &:hover {
    opacity: .7;
  }
`

const FooterMessage = styled.div`
  padding-top: 1rem;
  font-size: .875rem;
  line-height: 1.5rem;

  @media ${props => props.theme.media.md} {
    padding-top: 2.5rem;
  }
`

const FooterLink = styled.a`
  padding-top: 1rem;
  color: ${props => props.theme.members.colors.appleGreen._90};
  font-size: .875rem;
  font-weight: 700;
  text-decoration: underline;
  letter-spacing: .4px;
`

export const StyledRegistrationFinishWithJobOffer: React.FC<Props> = props => {
  const windowWidth = useWindowWidth()
  const isMobile = windowWidth < breakpoints.md

  return (
    <>
      <RegistrationFinishContainer>
        <Title>会員登録完了</Title>
        <SubTitle>この度はクラウドワークス テックにご登録いただきまして、誠にありがとうございます。</SubTitle>
        <ActionLinks>
          <ActionLinkArea>
            <ActionDescription>
              引き続き案件詳細ページより{isMobile ? <br /> : null}ご応募をお願いします
            </ActionDescription>
            {
              props.jobOfferSummary &&
              <JobOfferCardContainer>
                <JobOfferSummaryCard jobOfferSummary={props.jobOfferSummary} />
              </JobOfferCardContainer>
            }
            <ActionDescription>
              職務経歴書やポートフォリオをお持ちの場合、<br/>
              アップロードページからファイルを{isMobile ? <br /> : null}アップしてください
            </ActionDescription>
            <Image src={personUploading}></Image>
            <ActionAnchor href="/profile_sheet/resume_files">
              <ActionButton>アップロードページに移動する</ActionButton>
            </ActionAnchor>
          </ActionLinkArea>
        </ActionLinks>
        <FooterMessage>
          職務経歴書やポートフォリオを提出することで、{isMobile ? <br /> : null}あなたにマッチした案件をいち早く紹介できます
        </FooterMessage>
        <FooterLink href="/dashboard">マイページTOPへ</FooterLink>
      </RegistrationFinishContainer>
    </>
  )
}
